<template>
    <div id="app" class='mainApp'>
        <router-view></router-view>
    </div>
</template>

<script>
import { getters, contract as currentContract } from './contract'
import { capitalizeFirstLetter } from './utils/helpers'
import pools, { poolIds } from '@/constants/pools'

const getPageTitle = (poolId) => {
    if (!poolIds.includes(poolId)) return '';

    if (poolId === 'susd') return 'sUSD-yCurve old';

    return pools.getById(poolId).pageMetaData.title;
};

export default {
    metaInfo() {
        return {
            title: "Curve.finance",
            meta: [
                { 'property': 'og:title', 'content': 'curve.finance/' + this.currentPool },
                { 'property': 'og:url', 'content': 'https://classic.curve.finance/' + this.currentPool },
                { 'property': 'og:type', 'content': 'website' },
                poolIds.includes(this.currentPool) ?
                    { 'property': 'og:description', 'content': pools.getById(this.currentPool).pageMetaData.description } :
                    {},
                { 'property': 'og:image', 'content': '/curve' + this.currentPool + '_preview.png' },
                { 'name': 'twitter:card', 'content': 'summary_large_image' },
                { 'name': 'twitter:title', 'content': 'curve.finance/' + this.currentPool },
                { 'name': 'twitter:site', 'content': '@CurveFinance' },
                { 'name': 'twitter:creator', 'content': '@CurveFinance' },
                poolIds.includes(this.currentPool) ?
                    { 'name': 'twitter:description', 'content': pools.getById(this.currentPool).pageMetaData.description } :
                    {},
                { 'name': 'twitter:url', 'content': 'https://classic.curve.finance/' + this.currentPool },
                { 'name': 'twitter:image', 'content': this.currentPool + '/curve_preview.png' },
            ]
        }
    },
    computed: {
        ...getters,
    },
}
</script>
